import { mdlServiceResponse } from "../models/service-models/common/ServiceResponse";
import { mdlStopFreeSaleDetailRequest } from "../models/service-models/stop-free-sale/StopFreeSaleDetailRequest";
import { mdlStopFreeSaleDetailResponse } from "../models/service-models/stop-free-sale/StopFreeSaleDetailResponse";
import { mdlStopFreeSaleEmailRequest } from "../models/service-models/stop-free-sale/StopFreeSaleEmailRequest";
import { mdlStopFreeSaleEmailResponse } from "../models/service-models/stop-free-sale/StopFreeSaleEmailResponse";
import { mdlStopFreeSaleExportRequest } from "../models/service-models/stop-free-sale/StopFreeSaleExportRequest";
import { mdlStopFreeSaleExportResponse } from "../models/service-models/stop-free-sale/StopFreeSaleExportResponse";
import { mdlStopFreeSaleListRequest } from "../models/service-models/stop-free-sale/StopFreeSaleListRequest";
import { mdlStopFreeSaleListResponse } from "../models/service-models/stop-free-sale/StopFreeSaleListResponse";
import { mdlStopFreeSaleMessageRequest } from "../models/service-models/stop-free-sale/StopFreeSaleMessageRequest";
import { mdlStopFreeSaleMessageResponse } from "../models/service-models/stop-free-sale/StopFreeSaleMessageResponse";
import { mdlStopFreeSaleMessageUpdateResponse } from "../models/service-models/stop-free-sale/StopFreeSaleMessageUpdateResponse";
import { mdlStopFreeSaleReportOptionRequest } from "../models/service-models/stop-free-sale/StopFreeSaleReportOptionRequest";
import { mdlStopFreeSaleReportOptionResponse } from "../models/service-models/stop-free-sale/StopFreeSaleReportOptionResponse";
import { mdlStopFreeSaleReportRequest } from "../models/service-models/stop-free-sale/StopFreeSaleReportRequest";
import { mdlStopFreeSaleReportResponse } from "../models/service-models/stop-free-sale/StopFreeSaleReporResponse";
import { GetResponse } from "../utils/ApiClient";
import { mdlStopFreeSaleHotelAgencyMarketResponse } from "../models/service-models/stop-free-sale/StopFreeSaleHotelAgencyMarketResponse";
import { mdlStopFreeSaleHotelAgencyMarketRequest } from "../models/service-models/stop-free-sale/StopFreeSaleHotelAgencyMarketRequest";
import { mdlStopFreeSaleMessageUpdateRequest } from "../models/service-models/stop-free-sale/StopFreeSaleMessageUpdateRequest";
import { mdlStopFreeSaleSaveRequest } from "../models/service-models/stop-free-sale/StopFreeSaleSaveRequest";
import { mdlStopFreeSaleSaveResponse } from "../models/service-models/stop-free-sale/StopFreeSaleSaveResponse";
import { mdlStopFreeSaleRoomTypesRequest } from "../models/service-models/stop-free-sale/StopFreeSaleRoomTypesRequest";
import { mdlStopFreeSaleRoomTypesResponse } from "../models/service-models/stop-free-sale/StopFreeSaleRoomTypesResponse";
import { mdlStopFreeSaleSendRequest } from "../models/service-models/stop-free-sale/StopFreeSaleSendRequest";
import { mdlStopFreeSaleSendResponse } from "../models/service-models/stop-free-sale/StopFreeSaleSendResponse";
import { mdlStopFreeSaleCancelRequest } from "../models/service-models/stop-free-sale/StopFreeSaleCancelRequest";
import { mdlStopFreeSaleCancelResponse } from "../models/service-models/stop-free-sale/StopFreeSaleCancelResponse";
import { mdlStopFreeSaleMailServiceRequest } from "../models/service-models/stop-free-sale/StopFreeSaleMailServiceRequest";
import { mdlStopFreeSaleMailServiceResponse } from "../models/service-models/stop-free-sale/StopSaleFreeMailServiceResponse";

namespace StopFreeSaleService {
    export async function GetRoomTypes(
        pRequest: mdlStopFreeSaleRoomTypesRequest
    ): Promise<mdlServiceResponse<mdlStopFreeSaleRoomTypesResponse>> {
        return await GetResponse<mdlServiceResponse<mdlStopFreeSaleRoomTypesResponse>>(
            "stopFreeSale/get-room-types",
            pRequest
        );
    }
    export async function GetMessage(
        pRequest: mdlStopFreeSaleMessageRequest
    ): Promise<mdlServiceResponse<mdlStopFreeSaleMessageResponse>> {
        return await GetResponse<mdlServiceResponse<mdlStopFreeSaleMessageResponse>>(
            "stopFreeSale/get-messages",
            pRequest
        );
    }
    
    export async function UpdateMessage(
        pRequest: mdlStopFreeSaleMessageUpdateRequest
    ): Promise<mdlServiceResponse<mdlStopFreeSaleMessageUpdateResponse>> {
        return await GetResponse<mdlServiceResponse<mdlStopFreeSaleMessageUpdateResponse>>(
            "stopFreeSale/save-message",
            pRequest
        );
    }
    
    export async function GetList(
        pRequest: mdlStopFreeSaleListRequest
    ): Promise<mdlServiceResponse<mdlStopFreeSaleListResponse>> {
        return await GetResponse<mdlServiceResponse<mdlStopFreeSaleListResponse>>(
            "stopFreeSale/list",
            pRequest
        );
    }
    
    export async function GetDetail(
        pRequest: mdlStopFreeSaleDetailRequest
    ): Promise<mdlServiceResponse<mdlStopFreeSaleDetailResponse>> {
        return await GetResponse<mdlServiceResponse<mdlStopFreeSaleDetailResponse>>(
            "stopFreeSale/detail",
            pRequest
        );
    }
    
    export async function GetExport(
        pRequest: mdlStopFreeSaleExportRequest
    ): Promise<mdlServiceResponse<mdlStopFreeSaleExportResponse>> {
        return await GetResponse<mdlServiceResponse<mdlStopFreeSaleExportResponse>>(
            "stopFreeSale/get-mail",
            pRequest
        );
    }
    
    export async function SendRecord(
        pRequest: mdlStopFreeSaleSendRequest
    ): Promise<mdlServiceResponse<mdlStopFreeSaleSendResponse>> {
        return await GetResponse<mdlServiceResponse<mdlStopFreeSaleSendResponse>>(
            "stopFreeSale/send-record",
            pRequest
        );
    }
    
    export async function SendEmail(
        pRequest: mdlStopFreeSaleEmailRequest
    ): Promise<mdlServiceResponse<mdlStopFreeSaleEmailResponse>> {
        return await GetResponse<mdlServiceResponse<mdlStopFreeSaleEmailResponse>>(
            "stopFreeSale/send-mail",
            pRequest
        );
    }
    
    export async function GetReportOptions(
        pRequest: mdlStopFreeSaleReportOptionRequest
    ): Promise<mdlServiceResponse<mdlStopFreeSaleReportOptionResponse>> {
        return await GetResponse<mdlServiceResponse<mdlStopFreeSaleReportOptionResponse>>(
            "stopFreeSale/get-report-parameters",
            pRequest
        );
    }
    export async function GetReport(
        pRequest: mdlStopFreeSaleReportRequest
    ): Promise<mdlServiceResponse<mdlStopFreeSaleReportResponse>> {
        return await GetResponse<mdlServiceResponse<mdlStopFreeSaleReportResponse>>(
            "stopFreeSale/report",
            pRequest
        );
    }
    export async function GetReportDetail(
        pRequest: mdlStopFreeSaleReportRequest
    ): Promise<mdlServiceResponse<mdlStopFreeSaleReportResponse>> {
        return await GetResponse<mdlServiceResponse<mdlStopFreeSaleReportResponse>>(
            "stopFreeSale/report-detail",
            pRequest
        );
    }
    export async function GetHotelAgencyMarket(
        pRequest: mdlStopFreeSaleHotelAgencyMarketRequest
    ): Promise<mdlServiceResponse<mdlStopFreeSaleHotelAgencyMarketResponse>> {
        return await GetResponse<mdlServiceResponse<mdlStopFreeSaleHotelAgencyMarketResponse>>(
            "stopFreeSale/get-markets",
            pRequest
        );
    }
    export async function SaveStopFree(
        pRequest: mdlStopFreeSaleSaveRequest
    ): Promise<mdlServiceResponse<mdlStopFreeSaleSaveResponse>> {
        return await GetResponse<mdlServiceResponse<mdlStopFreeSaleSaveResponse>>(
            "stopFreeSale/save",
            pRequest
        );
    }
    
    export async function CancelOrNew(
        pRequest: mdlStopFreeSaleCancelRequest
    ): Promise<mdlServiceResponse<mdlStopFreeSaleCancelResponse>> {
        return await GetResponse<mdlServiceResponse<mdlStopFreeSaleCancelResponse>>(
            "stopFreeSale/cancel",
            pRequest
        );
    }
    
    export async function GetMailService(
        pRequest: mdlStopFreeSaleMailServiceRequest
    ): Promise<mdlServiceResponse<mdlStopFreeSaleMailServiceResponse>> {
        return await GetResponse<mdlServiceResponse<mdlStopFreeSaleMailServiceResponse>>(
            "stopFreeSale/get-mail-service",
            pRequest
        );
    }
}
export { StopFreeSaleService };
